import http from 'MeetingsBase/http/apiClient';
export const fetchAvatarForEmails = userEmails => http.post('avatars/v1/avatars/batch', {
  data: {
    hubSpotUserEmails: userEmails
  }
});